export default __webpack_public_path__ + "static/media/Template3-dark.d4d37288.png";